import updateCartQuantity from '../sections/slider-cart/updateCartQuantity';

const updateSliderCartQuantity = ($item, remove_from_cart) => {
  if (!$item.parent().hasClass('slider-cart__quantity') && !$item.hasClass('slider-cart__remove')) {
    return;
  }

  const updates = {};
  let qty = 0;

  if (!remove_from_cart) {
    qty = parseInt($item.parent().find('input').val(), 10);
  }
  updates[$item.closest('.slider-cart__item').data('variant-id')] = qty;
  updateCartQuantity(updates);
};

const updateCartPageQuantity = ($item) => {
  if (!$item.parent().hasClass('cart-item__quantity')) {
    return;
  }

  const updates = {};
  updates[$item.closest('.cart-item').data('variant-id')] = parseInt($item.parent().find('input').val(), 10);
  updateCartQuantity(updates);
};

const initQuantity = () => {
  $(document).on('click touchend', '[data-slider-cart-remove]', (e) => {
    e.stopPropagation();
    e.preventDefault();

    if ($('html').hasClass('cart-is-updating')) {
      return;
    }

    const $item = $(e.currentTarget);
    updateSliderCartQuantity($item, true);
  });

  $(document).on('click', '[data-quantity-increment]', (e) => {
    if ($('html').hasClass('cart-is-updating')) {
      return;
    }

    const $item = $(e.currentTarget);
    const $quantity_input = $item.parent().find('input');
    $quantity_input.val(parseInt($quantity_input.val(), 10) + 1);
  
    updateSliderCartQuantity($item, false);
    updateCartPageQuantity($item);
  });
  
  $(document).on('click', '[data-quantity-decrement]', (e) => {
    if ($('html').hasClass('cart-is-updating')) {
      return;
    }

    const $item = $(e.currentTarget);
    const $quantity_input = $item.parent().find('input');
  
    if ($quantity_input.val() > 1) {
      $quantity_input.val(parseInt($quantity_input.val(), 10) - 1);

      updateSliderCartQuantity($item, false);
      updateCartPageQuantity($item);
    }
  });
};

export { initQuantity };